import React from "react";
import "./placement_team.css";
import "../../page_content.css";

const PlacementTeam = () => {
  // Faculty Data (using cards)
  const PlacementTeam = [
    {
      img: "/assets/images/Placement/Rajiv Kashikar.webp",
      name: "Prof. Rajiv Kashikar",
      designation: "Chief Engineer, H.O.D. Placement & Training Department",
      contact: "020-67652663",
      email: " placements.manet@mituniversity.edu.in",
    },
    {
      img: "/assets/images/Placement/Seema Kawade.webp",
      name: "Prof. Kawade Seema Shashank",
      designation: "Placement Officer, Placement & Training Department",
      contact: " 020-67652663",
      email: " placements.manet@mituniversity.edu.in",
    },
  ];

  return (
    <div>
      <h1 className="title">Placement Team</h1>
      <hr />
      <p>
        The Placement Team, aims at providing the best opportunities enabling
        every cadet to realize his/her dream. This team is committed to the task
        of securing final placements for every deserving cadet on campus.
      </p>
      <h4 className="innerpage-subheading ">
        For more information, Please contact
      </h4>
      <div className="PlacementTeam-section">
        {/* PlacementTeam */}
        <div className="PlacementTeam-cards">
          {PlacementTeam.map((item, index) => (
            <div className="PlacementTeam-card" key={index}>
              {item.img && (
                <img
                  src={item.img}
                  alt={item.name}
                  className="PlacementTeam-photo"
                />
              )}
              <div className="PlacementTeam-info">
                {item.name && <h3 className="ach-name">{item.name}</h3>}
                {item.designation && (
                  <p className="PlacementTeam-text">{item.designation}</p>
                )}
                {item.contact && (
                  <p className="PlacementTeam-text">
                    Contact no.-
                    <a href={`tel:${item.contact}`} className="phone-link">
                      {item.contact}
                    </a>
                  </p>
                )}
                {item.email && (
                  <p className="PlacementTeam-text">E-mail-{item.email}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PlacementTeam;
